import { render } from "./PageViewPSBditolakv2.vue?vue&type=template&id=ae950cba"
import script from "./PageViewPSBditolakv2.vue?vue&type=script&lang=js"
export * from "./PageViewPSBditolakv2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__